module.exports = global["jQuery"] = require("-!/home/vsts/work/1/s/WebsiteSolution/BBSCatalyst.Web/fe/node_modules/expose-loader/index.js?$!./jquery.js");